import { useEffect, useState } from "react";
import { _Entailment, _single } from "../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { BasicTable } from "../../../theme/Component/BasicTable";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { Modal } from "../../../theme/Component/Modal";
import { Singleton } from '../../../../core/services/Singleton';
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import { toast } from "react-toastify";
import usePaginator from "../../../theme/Component/usePaginator";
import { _AddCommercialCampaign, _AirLine, _Airport, _CommercialCampaign, _CustomerAddress, _TransportRoute } from "../../../../core/services/dataBean/EntityCatalogVdos";
import { BasicButton } from "../../../theme/Component/BasicButton";
import { AccountEditor } from "../../../editor/AccountEditor";
import { SelectSiteID } from "../../../admin/configuracion/SiteID/SelectSiteID";
import { BasicSwitch } from "../../../theme/Component/BasicSwitch";
import { CitiesEditor } from "../Countries/Cities/CitiesEditor";
import { TransportDestinationEditor } from "../TransportDestination/TransportDestinationEditor";
import { SelectAccountantConceptCatalogForSalesInvoice } from "../../../contract/etapa-contrato/contrac/ublinvoice/SelectAccountantConceptCatalogForSalesInvoice";
import { SelectProductEditor } from "../../../Factoty&Production/ManufacturingStandars/Components/SelectProductEditor";


export const TransportRoute = () => {

    const tansproute = useDataBean(_TransportRoute);
    const paginador = usePaginator();
    const [regexStr, setregexStr] = useState<any>(null)
    const single = Singleton.getInstance();
    const [lista, setLista] = useState<any>([]);
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        getLista();
    }, [paginador.page])

    const getLista = () => {

        tansproute.instance.getTransportRouteCatalog(regexStr, paginador.page, 15).then(
            (resp: any) => {
                if (resp) {
                    paginador.setPages(resp.NumberOfPages);
                    paginador.setRecords(resp.NumberOfPages * (15));
                    paginador.setRegiPerPage(15)
                    // setLista(resp.List)
                    let x = resp.List;
                    x.forEach((user) => {
                        user.DataBeanProperties.ProductName = (user.DataBeanProperties.ProductDescription ?? "") + "-" + (user.DataBeanProperties.Reference ?? "") + "-" + (user.DataBeanProperties.ProductCode ?? "") + "-" + (user.DataBeanProperties.UBLMeasurementUnitCode ?? "") + "-" + (user.DataBeanProperties.UBLMeasurementUnitName ?? "");
                    });
                    setLista(x)
                }
            }
        )

    }
    const create = () => {
        tansproute.setBean({

        });
        setModal({ ...modal, "view": true });
    }
    const deleteItem = () => {
        tansproute.instance.deleteTransportRoute(tansproute.bean.IDTransportRoute).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "view": false });
            }
        )

    }
    const editaItem = () => {
        //console.log(entailment.bean);
        tansproute.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const head = [
        { title: 'ID', property: 'IDTransportRoute', visible: true },
        { title: 'Orígen', property: 'TransportDestinationOrigin', visible: true },
        { title: 'Destino', property: 'TransportDestinationDestinity', visible: true },
        { title: 'Producto', property: 'ProductName', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },
        { title: 'Habilitada', property: 'Enabled', visible: true },
    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <BasicPage titulo="Rutas de Transporte">
            <div className="row">
                <div className="col-md-6">
                    <label>Búsqueda por Texto</label>
                    <input type="text" className="form-control" value={regexStr} onChange={(e) => { setregexStr(e.target.value) }} />
                </div>
                <div className="col-md-6 mt-4 p-2">
                    <BasicButton icon="ri-align-justify" eventClick={getLista}>Buscar</BasicButton>
                </div>
                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={tansproute.setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem} pageTop={paginador.page} next={paginador.next} back={paginador.back} records={paginador} customRows={15}></BasicTable>
                    <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                        <div className="row">
                            <div className="col-md-6">
                                <TransportDestinationEditor render={tansproute.bean.TransportDestinationOrigin} idSelector={tansproute.bean.IDTransportDestinationOrigin} onChange={(e) => { tansproute.setBean({ ...tansproute.bean, "IDTransportDestinationOrigin": e.IDTransportDestination, "TransportDestinationOrigin": e.SiteIDName }) }} returnType="Object" />
                            </div>
                            <div className="col-md-6">
                                <TransportDestinationEditor label='Destino' render={tansproute.bean.TransportDestinationDestinity} idSelector={tansproute.bean.IDTransportDestinationDestinity} onChange={(e) => { tansproute.setBean({ ...tansproute.bean, "IDTransportDestinationDestinity": e.IDTransportDestination, "TransportDestinationDestinity": e.SiteIDName }) }} returnType="Object" />
                            </div>
                            <div className="col-md-6">
                                <SelectAccountantConceptCatalogForSalesInvoice label='Concepto de Ingreso' idSelector={tansproute.bean.IDAccountantConcept} onChange={(e) => { tansproute.setBean({ ...tansproute.bean, "IDAccountantConcept": e }) }} />
                            </div>
                            <div className="col-md-6">
                                <SelectProductEditor value={tansproute.bean.IDProduct} label="Producto Final" onChange={(e) => { tansproute.setBean({ ...tansproute.bean, "IDProduct": e.IDProduct }) }} />
                            </div>
                            <div className="col-md-6 mt-4">
                                <BasicSwitch label="Habilitada" estado={tansproute.bean.Enabled} eventChange={(e: any) => { tansproute.setBean({ ...tansproute.bean, "Enabled": e }) }}></BasicSwitch>
                            </div>
                            <div className="col-md-12">
                                <label>Descripción</label>
                                <textarea name="Description" className="form-control" value={tansproute.bean.Description} onChange={tansproute.handleChange} />
                            </div>
                        </div>
                    </Modal>
                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item {tansproute.bean.Name}</strong>
                    </ModalConfirm>
                </div>

            </div>
        </BasicPage>
    )
}